import { ReactNode } from 'react';

const ApiDocumentationApp = ({ children }: { children: ReactNode }) => (
  <div className="api-documentation">{children}</div>
);

export default ApiDocumentationApp;
